/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF, useAnimations, useTexture } from "@react-three/drei";
import model from "./Escola_V8.glb";
import tangram from "./materials/Tangram_Diffuse.jpg";
import boxWood from "./materials/T_Boxwood_wfypfa3ha_1K_D.jpg";
import pisoPorta from "./materials/PisoPorta_Diffuse.jpg";
export default function Model({ ...props }) {
  const group = useRef();
  const { nodes, materials, animations } = useGLTF(model);
  const tangramTexture = useTexture(tangram);
  const boxWoodTexture = useTexture(boxWood);
  const pisoPortaTexture = useTexture(pisoPorta);
  const { actions } = useAnimations(animations, group);
  Object.entries(materials).forEach(([key, value]) => {
    value.envMapIntensity = props.envMapIntensity;
  });
  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <mesh
          name="Cadeiras02"
          geometry={nodes.Cadeiras02.geometry}
          material={materials.Cadeiras02}
          position={[-0.8, 0.31, 2]}
        />
        <mesh
          name="Cadeiras01"
          geometry={nodes.Cadeiras01.geometry}
          material={materials.Cadeiras01}
          position={[1.19, 0.31, 2]}
        />
        <mesh
          name="Cadeiras03"
          geometry={nodes.Cadeiras03.geometry}
          material={materials.Cadeiras03}
          position={[-2.79, 0.31, 2]}
        />
        <mesh
          name="Mesa02"
          geometry={nodes.Mesa02.geometry}
          material={materials.Mesas02}
          position={[-0.8, 0.75, -2.56]}
        />
        <mesh
          name="Mesas01"
          geometry={nodes.Mesas01.geometry}
          material={materials.Mesas01}
          position={[1.19, 0.75, -2.56]}
        />
        <mesh
          name="Mesa03"
          geometry={nodes.Mesa03.geometry}
          material={materials.Mesas03}
          position={[-2.79, 0.75, -2.56]}
        />
        <mesh
          name="PisoPorta"
          geometry={nodes.PisoPorta.geometry}
          material={materials.PisoPorta}
          material-map={pisoPortaTexture}
          material-map-flipY={false}
          material-roughness={0}
          position={[0, 0, -0.73]}
        />
        <mesh
          name="MesaCadeira"
          geometry={nodes.MesaCadeira.geometry}
          material={materials.MesaCadeira}
          position={[1.99, 0.75, 4.18]}
          rotation={[Math.PI, 0, Math.PI]}
        />
        <mesh
          name="Paredes"
          geometry={nodes.Paredes.geometry}
          material={materials.Paredes}
          position={[3.5, 1.5, -0.73]}
        />
        <mesh
          name="Forro"
          geometry={nodes.Forro.geometry}
          material={materials.Forro}
          position={[-0.03, 3, 0.39]}
        />
        <mesh
          name="Detalhes"
          geometry={nodes.Detalhes.geometry}
          material={materials.Detalhes}
          position={[3.56, 2.56, 0.4]}
        />
        <mesh
          name="VidroJanelaCorredor"
          geometry={nodes.VidroJanelaCorredor.geometry}
          material={materials.VidroJateado}
          position={[3.56, 2.56, 0.4]}
        />
        <mesh
          name="Tangram"
          geometry={nodes.Tangram.geometry}
          material={materials.Tangram}
          material-map={tangramTexture}
          material-map-flipY={false}
          position={[0.19, 1.9, -4.22]}
          rotation={[Math.PI / 2, 0, -Math.PI]}
          scale={-1}
        />
        <mesh
          name="VidroPorta"
          geometry={nodes.VidroPorta.geometry}
          material={materials["Vidro Fosco"]}
          position={[3.51, 1.05, 3.11]}
        />
        <mesh
          name="BaffleLoop"
          geometry={nodes.BaffleLoop.geometry}
          material={materials.Baffle}
          position={[0.19, 3.05, 3.96]}
          scale={[1, 0.42, 1]}
        />
        <mesh
          name="Nichos"
          geometry={nodes.Nichos.geometry}
          material={materials.Nichos}
          position={[3.01, 0.34, -0.43]}
          rotation={[Math.PI, 0, Math.PI]}
        />
        <mesh
          name="S_Boxwood_wfypfa3ha_Var1_lod3"
          geometry={nodes.S_Boxwood_wfypfa3ha_Var1_lod3.geometry}
          position={[-6.38, -0.14, 5.93]}
          scale={0.04}
        >
          <meshBasicMaterial map={boxWoodTexture} map-flipY={false} />
        </mesh>
        <mesh
          name="S_Boxwood_wfypfa3ha_Var3_lod3"
          geometry={nodes.S_Boxwood_wfypfa3ha_Var3_lod3.geometry}
          material={materials.MI_Boxwood_wfypfa3ha_1K}
          position={[-6.14, 0, 1.33]}
          scale={0.03}
        >
          <meshBasicMaterial map={boxWoodTexture} map-flipY={false} />
        </mesh>
        <mesh
          name="S_Boxwood_wfypfa3ha_Var10_lod3"
          geometry={nodes.S_Boxwood_wfypfa3ha_Var10_lod3.geometry}
          material={materials.MI_Boxwood_wfypfa3ha_1K}
          position={[-6.05, 0, -2.52]}
          scale={0.05}
        >
          <meshBasicMaterial map={boxWoodTexture} map-flipY={false} />
        </mesh>
        <mesh
          name="Vidro"
          geometry={nodes.Vidro.geometry}
          material={materials.Vidro}
          position={[-3.53, 1.5, 0.4]}
          scale={[0.01, 1, 1]}
        />
      </group>
    </group>
  );
}

useGLTF.preload(model);
